import { cn } from '@/lib/utils';

export interface SecondaryProductCopyInput {
  primaryName?: string | null;
  primaryDescription?: string | null;
  name2?: string | null;
  description2?: string | null;
}

export function getSecondaryProductCopy({
  primaryName,
  primaryDescription,
  name2,
  description2,
}: SecondaryProductCopyInput): { name: string | null; description: string | null } {
  const distinct = (primary?: string | null, translated?: string | null) => {
    const value = translated?.trim();
    if (!value) return null;
    return value.localeCompare(primary?.trim() ?? '', undefined, { sensitivity: 'base' }) === 0
      ? null
      : value;
  };

  return {
    name: distinct(primaryName, name2),
    description: distinct(primaryDescription, description2),
  };
}

export function SecondaryProductCopy({
  primaryName,
  primaryDescription,
  name2,
  description2,
  className,
  nameClassName,
  descriptionClassName,
}: SecondaryProductCopyInput & {
  className?: string;
  nameClassName?: string;
  descriptionClassName?: string;
}) {
  const copy = getSecondaryProductCopy({ primaryName, primaryDescription, name2, description2 });
  if (!copy.name && !copy.description) return null;

  return (
    <div className={cn('space-y-0.5', className)} data-secondary-product-copy="true">
      {copy.name && <p className={nameClassName}>{copy.name}</p>}
      {copy.description && (
        <p className={cn('whitespace-pre-line', descriptionClassName)}>{copy.description}</p>
      )}
    </div>
  );
}
